export class GetMeta {
  constructor (metadata) {
    // super(props);
    try {
      const countryTranslations = JSON.parse(metadata['translations']).language[utils.userType.checkRegion()];
      Object.assign(this, {
        translations(key, defaults) {
          if (key) {
            return countryTranslations?.[key] || defaults;
          }

          return defaults || '';
        },
        metadata(key, defaults) {
          if (key) {
            try {
              return JSON.parse(metadata?.[key]);
            } catch (error) {
              return defaults || {};
            }
          }
          return defaults || '';
        },
      });
    } catch(e) {
      console.debug('error metadata',e);
    }
  }
}
